import * as React from 'react';

export interface WixStyleReactEnvironmentProviderProps {
  /** any content to be displayed */
  children?: React.ReactNode;
  /** Define the user locale to be used and effect some translation and localization (like DatePicker) - this should be compliant to Intl language codes*/
  locale?: string;
  /** Define id that will be applied to the header of a main page */
  pageHeaderId?: string;
}
